import React from "react";
import { Container, Card } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Products = () => {
  return (
    <>
      <Navbar />
      <Container className="py-5">
        <h2 className="text-center mb-4">Our Products</h2>
        
        <Card className="p-4 shadow-lg">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-4">Loan Products</h2>
          <h3 className="text-2xl font-semibold text-gray-800 text-center mb-4">Various Loan Products</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {[ 
              { name: "Development loan", img: "/assets/img2.jpg", details: "Maximum loan is 3 times members deposit. Maximum repayment period of 48 months. Interest rate of 1% per month. Processing fee of 1.5%. Guarantors or collateral can be used as security." },
              { name: "Investment loan", img: "/assets/img6.jpg", details: "Maximum loan is 3 times member’s deposit. Maximum repayment period of 48 months. Interest rate is 1.2% per month. Processing fee of 1.5%." },
              { name: "Asset Finance", img: "/assets/img3.jpg", details: "Maximum loan is 80% of the asset value. Maximum repayment period is 60 months. Interest rate is 1.2%. Security of the loan is the asset." },
              { name: "School fees loan", img: "/assets/img8.jpg", details: "Maximum amount is 200,000. Interest rate of 1% per month. Processing fee of 1.5%. Maximum repayment period of 24 months." },
              { name: "Emergency loan", img: "/assets/img9.jpg", details: "Maximum amount is 50,000. Maximum repayment period is 12 months. Loan interest is 1% per month. Processing fee of 1.5%." },
              { name: "Instant loan", img: "/assets/img10.jpg", details: "Maximum loan is 30,000. Maximum repayment period is 4 months. Loan interest of 10%. Application available online." },
            ].map((loan, index) => (
              <div key={index} className="p-6 bg-white rounded-lg shadow-lg text-center">
                <img src={loan.img} alt={loan.name} className="w-full mb-4" />
                <h3 className="text-xl font-semibold text-gray-800">{loan.name}</h3>
                <p className="text-gray-600">{loan.details}</p>
              </div>
            ))}
          </div>
        </Card>
        
        <Card className="p-4 mt-5 shadow-lg">
          <h3 className="text-2xl font-semibold text-gray-800 text-center mb-4">Savings Products</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {[ 
              { name: "Non-withdrawable deposit", img: "/assets/img11.jpg", details: "It is refundable upon exit from the sacco. The minimum deposit is Ksh 2,000 and loans are offered at *3 multiplier." },
              { name: "Target deposit", img: "/assets/img12.jpg", details: "A voluntary withdrawable savings scheme for members which earns them an interest of 8% per annum compounded monthly." }
            ].map((saving, index) => (
              <div key={index} className="p-6 bg-white rounded-lg shadow-lg text-center">
                <img src={saving.img} alt={saving.name} className="w-full mb-4" />
                <h3 className="text-xl font-semibold text-gray-800">{saving.name}</h3>
                <p className="text-gray-600">{saving.details}</p>
              </div>
            ))}
          </div>
        </Card>
      </Container>
      <Footer />
    </>
  );
};

export default Products;
